<section>

  <span class="ghost-icon ghost-1"><i class="pi pi-building"></i></span>
  <span class="ghost-icon ghost-2"><i class="pi pi-wrench"></i></span>
  <span class="ghost-icon ghost-3"><i class="pi pi-cog"></i></span>

  <button class="close-btn" (click)="closeDialog()" aria-label="Cerrar">
    <i class="pi pi-times"></i>
  </button>

  <div class="modal-body">
    <img src="/assets/images/logos/logo.png" alt="Paredes y Asociados Constructores" class="logo">
    <h3>
      Construye con quien<br>
      <strong>lleva 30 años haciéndolo bien.</strong>
    </h3>
    <p>Comparte los alcances de tu proyecto y recibe una propuesta profesional a tu medida.</p>
    <div class="chips">
      <span class="chip">Certificada</span>
      <span class="chip">Calidad</span>
      <span class="chip">Puntualidad</span>
      <span class="chip">Seguridad</span>
    </div>
    <a routerLink="/gracias/whatsapp" class="cta-btn" (click)="closeDialog()">
      Solicitar cotización
    </a>
  </div>

  <!-- <div class="modal-footer">
    <img src="/assets/images/logos/logo-30-anos-padi.webp" alt="30 Años PADI" class="badge-30">
    <div class="footer-text">
      <span class="footer-title">30 años construyendo confianza</span>
      <span class="footer-sub">Empresa mexicana certificada · Obra pública y privada</span>
    </div>
  </div> -->
</section>
